import { APIs, API_BASE_URL, SERVICEURL } from "../constants/Constants";
import { _base64ToArrayBuffer } from "./StudyViewerService";
import axiosInterceptor from "../helpers/Interceptor";

export const getUserActionList = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + "jwtServices/audit/useraction",
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getSearchedAuditLogList = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.AUDITLOGSEARCH, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getSearchIssueStatusList = async(body) =>{
  try{
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.ISSUESTATUSSEARCH,
      {
        data: body,
      }
    );
    return response;
  }catch(error){
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}

export const updateIssueStatus = async(id, value) =>{
  try{
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.UPDATE_ISSUE_STATUS,
      {
        data: {
          id : id, 
          status : value
        }
      }
    );
    return response;
  }catch(error){
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}
export const updateAllIssueStatus = async() =>{
  try{
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.UPDATE_ISSUE_STATUS_ALL,
      {}
    );
    return response;
  }catch(error){
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}


export const getAuditLogsList = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.AUDITLOGSLIST, {});
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const downloadAuditLogsCSVService = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADAUDITLOG,
      { data: body },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.status === 200) {
      const fileData = _base64ToArrayBuffer(response.data.data.data);
      const file = new Blob([fileData]);
      const url = window.URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.data.data.filename);
      document.body.appendChild(link);
      link.click();
    }
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const errorListCSVService = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADERRORLISTLOG,
      { data: body },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.status === 200) {
      const fileData = _base64ToArrayBuffer(response.data.data.data);
      const file = new Blob([fileData]);
      const url = window.URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.data.data.filename);
      document.body.appendChild(link);
      link.click();
    }
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
